import React from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';

const BankDetails = () => {
    return (
        <div>
            <Container>
                <div className="row mt-4">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header" style={{ backgroundColor: "rgb(0,156,216)", color: 'white' }}>
                                <h4>Bank Details</h4>
                            </div>
                            <div className="d-flex justify-content-around">
                                <Link to="/Bankaccountdetails">
                                    <button className='btn btn-warning mt-4 mx-4 mb-4'>Users</button>
                                </Link>
                                <Link to="/Bankvendor">
                                    <button className='btn btn-warning mt-4 mx-4 mb-4'>Vendor</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default BankDetails;
